import { useMemo } from "react"

import { useGeoServerRetrieveFeature } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { RoadDetailInfo } from "@l2r-front/l2r-networks"
import { Typography } from "@l2r-front/l2r-ui"
import { formatMetersToDistance } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { ROADWORK_ATTACHMENT, SECTION_ATTACHMENT } from "../../constants/modules"

import * as Styled from "./DocumentDetailsRoadInfo.styled"

export function DocumentDetailsRoadInfo(props) {

    const {
        attachedObject,
        attachmentType,
        road,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const itemGeometry = attachedObject?.geometry || null
    const { data: feature, isError, isLoading } = useGeoServerRetrieveFeature(attachedObject?.feature)

    const LengthComponent = useMemo(() => {
        if (!attachedObject) {
            return <Styled.Skeleton />
        }
        if (itemGeometry?.type === "Point") {
            return ({
                lengthLabel: `${t(I18N_NAMESPACE, "components.documentDetailsRoadInfo.latlong")} `,
                LengthComponent: <Typography id="road-detail-latlong" variant="Regular">
                    {itemGeometry.coordinates[1].toFixed(5)}, {itemGeometry.coordinates[0].toFixed(5)}
                </Typography>,
            })
        }
        if (attachmentType === ROADWORK_ATTACHMENT || attachmentType === SECTION_ATTACHMENT) {
            if (isLoading) {
                return <Styled.Skeleton />
            }
            if (!isError) {
                const lengthInMeters = formatMetersToDistance(computeRoadworkLength(feature.linear_locations))
                const lengthLabel = attachmentType === ROADWORK_ATTACHMENT
                    ? "components.documentDetailsRoadInfo.roadworkLength"
                    : "components.documentDetailsRoadInfo.sectionLength"
                return ({
                    lengthLabel: `${t(I18N_NAMESPACE, lengthLabel)} `,
                    LengthComponent: <Typography id="road-detail-length" variant="Regular">
                        {lengthInMeters}
                    </Typography>,
                })
            }
        }
        return null
    }, [attachedObject, attachmentType, feature, isError, isLoading, itemGeometry, t])

    return <RoadDetailInfo {...LengthComponent} road={road} />
}

export const computeRoadworkLength = (linearLocation) => {
    return linearLocation?.reduce((lengthAcc, segment) => {
        return lengthAcc + Math.abs(segment.end - segment.start)
    }, 0)
}